module.exports = __webpack_public_path__ + "static/media/extract_time.6f7dc5b8.svg";